import { Button } from "react-aria-components"
import { choiceCardClassName } from "./choice-card-chrome"
import type { ChoiceCardFaceProps } from "./ChoiceCardFace"
import { ChoiceCardFace } from "./ChoiceCardFace"

export interface ChoiceButtonOption<Value extends string> extends ChoiceCardFaceProps {
  value: Value
}

/**
 * Choice cards that answer a question rather than hold a value: pressing one moves the flow
 * straight on, so the view carries no Done button. Use {@link
 * import("./ChoiceCards").ChoiceCards} instead when the choice is one field of a form the
 * user submits later.
 */
export function ChoiceButtons<Value extends string>({
  ariaLabel,
  options,
  onChoose,
}: {
  ariaLabel: string
  options: Array<ChoiceButtonOption<Value>>
  onChoose: (value: Value) => void
}) {
  return (
    <div role="group" aria-label={ariaLabel} className="flex flex-col gap-2.5">
      {options.map(({ value, ...face }) => (
        <Button
          key={value}
          data-test="choice button"
          // hover-below-pointer finds a card with this attribute.
          data-choice-card
          className={({ isFocusVisible }) => choiceCardClassName({ isFocusVisible })}
          onPress={() => onChoose(value)}
        >
          <ChoiceCardFace {...face} />
        </Button>
      ))}
    </div>
  )
}
